import { getCollectionValue, getSharedValue, getValuesFromCollection } from '../shared-store-reader';
import { valueMeetsCriteria, waitForUpdate } from './shared-values-context';
import { produce } from 'immer';
var SharedCollectionContext = /** @class */ (function () {
    function SharedCollectionContext(store) {
        this.store = store;
    }
    SharedCollectionContext.prototype.get = function (key, valueKeyOrKeys) {
        var collection = this.getCollection(key);
        if (Array.isArray(valueKeyOrKeys)) {
            return getValuesFromCollection(collection, key, valueKeyOrKeys);
        }
        else {
            return getCollectionValue(collection, key, valueKeyOrKeys);
        }
    };
    SharedCollectionContext.prototype.getAll = function (key) {
        var collection = this.getCollection(key);
        var keys = collection.allKeys();
        return getValuesFromCollection(collection, key, keys);
    };
    SharedCollectionContext.prototype.waitFor = function (key, valueKey, criteria) {
        if (!valueKey)
            throw Error("Attempt to wait for an undefined value key for ".concat(key.id));
        var collection = this.getCollection(key);
        var value = getCollectionValue(collection, key, valueKey);
        if (valueMeetsCriteria(value, criteria))
            return Promise.resolve(value);
        else
            return waitForUpdate(collection, valueKey, criteria);
    };
    SharedCollectionContext.prototype.changes = function (key, valueKeyOrKeys) {
        var collection = this.getCollection(key);
        return collection.onChange(valueKeyOrKeys);
    };
    SharedCollectionContext.prototype.anyChanges = function (key) {
        var collection = this.getCollection(key);
        return collection.onAnyChange();
    };
    SharedCollectionContext.prototype.set = function (key, valueKey, value) {
        var _a;
        if (valueKey) {
            var resolver = key.resolver;
            var collection = this.getCollection(key);
            collection.setValue(valueKey, value);
            if (resolver)
                resolver.valuesChanged((_a = {}, _a[valueKey] = value, _a));
        }
        else {
            console.warn("Attempt to set a value for undefined value key in ".concat(key.id));
        }
    };
    SharedCollectionContext.prototype.modify = function (key, valueKey, modify) {
        var current = this.get(key, valueKey);
        var newValue = produce(current, modify);
        this.set(key, valueKey, newValue);
    };
    SharedCollectionContext.prototype.modifyAll = function (key, modify) {
        var collection = this.getCollection(key);
        var keys = collection.allKeys();
        var update = {};
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key_1 = keys_1[_i];
            var current = collection.getValue(key_1);
            update[key_1] = produce(current, modify);
        }
        this.update(key, update);
    };
    SharedCollectionContext.prototype.update = function (key, update) {
        var resolver = key.resolver;
        var collection = this.getCollection(key);
        collection.update(update);
        if (resolver)
            resolver.valuesChanged(update);
    };
    SharedCollectionContext.prototype.delete = function (key, valueKey) {
        if (valueKey) {
            var resolver = key.resolver;
            var collection = this.getCollection(key);
            var keys = Array.isArray(valueKey) ? valueKey : [valueKey];
            collection.delete(keys);
            if (resolver)
                resolver.valuesRemoved(keys);
        }
        else {
            console.warn("Trying to delete an undefined value key in ".concat(key.id));
        }
    };
    SharedCollectionContext.prototype.clear = function (key) {
        var resolver = key.resolver;
        var collection = this.getCollection(key);
        var keys = collection.allKeys();
        if (keys && keys.length > 0) {
            collection.delete(keys);
        }
        if (resolver)
            resolver.valuesRemoved(keys);
    };
    SharedCollectionContext.prototype.getCollection = function (key) {
        return getSharedValue(this.store, key);
    };
    return SharedCollectionContext;
}());
export { SharedCollectionContext };
//# sourceMappingURL=shared-collection-context.js.map